import { useMemo } from 'react';
import { ProductDto } from 'api/repositories/product/product.types';
import { getLanguage } from 'assets/languages';
import URLS from 'constants/urls';

interface GuidelineRulesModalProps {
  productId: ProductDto['id'];
}

function GuidelineRulesModal({ productId }: GuidelineRulesModalProps) {
  const language = getLanguage();
  const cacheBusterVersion = useMemo(() => new Date().getTime(), []);

  return (
    <iframe
      id="test-iframe"
      data-test="test"
      className="w-full h-[100vh]"
      src={`${URLS.WEB_VIEW.URL}/${language}/product/${productId}/guidelineRules?context=brand_iframe&v=${cacheBusterVersion}`}
    />
  );
}

export default GuidelineRulesModal;
